import { useState } from 'react';
import Badge from '@mui/material/Badge';
import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import { Icon } from '@mui/material';

import useCart from "hooks/useCart";
import CartDrawer from "components/Home/products/components/CartDrawer";

const StyledBadge = styled(Badge)(({ theme }) => ({
  '& .MuiBadge-badge': {
    right: -3,
    top: 13,
    border: `2px solid ${theme.palette.background.paper}`,
    padding: '0 4px',
  },
}));

const list ={ bag : 'shopping_bag', mall : 'local_mall', basket : 'shopping_basket', cart : 'shopping_cart',garden : 'garden_cart'}

export default function ShoppingCart({ badgeColor, cartType, color, size }) {
  const {cart} = useCart();
  const [state, setState] = useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });

  const toggleDrawer = (anchor, open)  => {
    setState({ ...state, [anchor]: open });
  };
  return (
    <>
    <IconButton aria-label="cart" size={size} onClick={()=>toggleDrawer("right",true)} color={color}>
      <StyledBadge badgeContent={cart.quantity} color={badgeColor}>
        <Icon>{list[cartType]}</Icon>
      </StyledBadge>
    </IconButton>
    <CartDrawer toggleDrawer={toggleDrawer} state={state} anchor="right"/>
    </>
  );
}